export const normalizeEmail = (value) => (
    String(value || "").trim().toLowerCase()
);

export const isInternalQflowEmail = (value) => (
    normalizeEmail(value).endsWith("@qflow.ai")
);
